import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './SchemeSidebar.css';
import Dropdown from './SchemeDropdown';

const SchemeSidebar = ({ setFilters, setHeatmapData }) => {
  const navigate = useNavigate();

  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);

  const [schemes, setSchemes] = useState([]);
  const [serviceTypes, setServiceTypes] = useState([]);

  const [selectedFilters, setSelectedFilters] = useState({
    serviceType: '',
    scheme: '',
    heatmapType: '',
  });

  useEffect(() => {
    fetch('/db2_sales.json')
      .then(response => response.json())
      .then(data => {
        setData(data);
        setFilteredData(data);
        updateFilters(data);
        if (setHeatmapData) setHeatmapData(data);
      })
      .catch(error => console.error('Error fetching data:', error));
  }, []);

  // ✅ Safer updateFilters
  const updateFilters = (data) => {
    const schemeNames = data.map(item => item.parent_scheme_name || item.scheme_name).filter(Boolean);
    const serviceTypeNames = data.map(item => item.Type_Sch_Doc).filter(Boolean);
  
    setSchemes([...new Set(schemeNames)]);
    setServiceTypes([...new Set(serviceTypeNames)]);
  };
  
  const handleFilterChange = (filterKey, value) => {
    setSelectedFilters(prev => ({
      ...prev,
      [filterKey]: value,
    }));
    setFilters(filterKey, value);
  
    let newFilteredData = data;
  
    switch (filterKey) {
      case 'serviceType':
        newFilteredData = data.filter(item => item.Type_Sch_Doc === value);
        const filteredSchemes = new Set(
          newFilteredData.map(item => item.parent_scheme_name || item.scheme_name).filter(Boolean)
        );
        setSchemes([...filteredSchemes]);
        break;
      case 'scheme':
        newFilteredData = data.filter(
          item => (item.parent_scheme_name || item.scheme_name) === value
        );
        break;
      case 'heatmapType':
        // Implement filtering based on heatmapType
        break;
      default:
        break;
    }
  
    setFilteredData(newFilteredData);
    updateFilters(newFilteredData);
    if (setHeatmapData) setHeatmapData(newFilteredData);
  };
  
  const handleClearAllFilters = () => {
    setSelectedFilters({ serviceType: '', scheme: '', heatmapType: '' });
    setFilters('serviceType', '');
    setFilters('scheme', '');
    setFilters('heatmapType', '');

    setFilteredData(data);
    updateFilters(data);
    if (setHeatmapData) setHeatmapData(data);
  };

  // ✅ Safe filterOptions
  // ✅ Safe filterOptions
const filterOptions = {
  serviceType: serviceTypes,
  scheme: selectedFilters.serviceType
    ? [...new Set(filteredData.map(item => item.parent_scheme_name || item.scheme_name).filter(Boolean))]
    : schemes,
};


  const capitalizeFirstLetter = (string) => {
    return string ? string.charAt(0).toUpperCase() + string.slice(1) : '';
  };

  return (
    <aside className="scheme-sidebar">
      <nav>
        <h2 className="scheme-sidebar-header">Filter Data By</h2>
        <ul className="scheme-sidebar-list">
          {Object.keys(selectedFilters).map((filterKey) => (
            filterKey !== 'heatmapType' && (
              <li className="scheme-sidebar-item" key={filterKey}>
                <div className="dropdown-container">
                  <Dropdown
                    label="Select"
                    options={filterOptions[filterKey] || []}
                    header={capitalizeFirstLetter(filterKey)}
                    selectedOption={selectedFilters[filterKey]}
                    onSelect={(value) => handleFilterChange(filterKey, value)}
                  />
                </div>
              </li>
            )
          ))}
        </ul>
        <button className="clear-all-filters-button12" onClick={handleClearAllFilters}>
          Clear All Filters
        </button>
        <button className="back-button" onClick={() => navigate(-1)}>
          Back To Home
        </button>
      </nav>
    </aside>
  );
};

export default SchemeSidebar;
